import { InjectionToken } from '@angular/core';

export const SERIES_NAME = new InjectionToken<string>('SERIES_NAME');
export const SWISS_TIMING_ENABLED = new InjectionToken<boolean>('SWISS_TIMING_ENABLED');
export const RACE_DATA_FROM_EXTERNAL_SOURCE = new InjectionToken<boolean>('RACE_DATA_FROM_EXTERNAL_SOURCE');
	